/* eslint-disable max-len */

const custom_text = {
    field_type: 'input',
    key: 'text',
    element: {
        placeholder: 'e.g. photography, social media, astronomy',
    },
}

const note = {
    field_type: 'note',
    calculated_values: {
        html() {
            return `Messages will be sent to <span class="text ellipsis">${this.user.get('email_address')}.</span> Your email address will not be displayed.`
        },
    },
}

const buttonset = {
    field_type: 'buttonset',
    buttons: [
        {
            type: 'submit',
            label: 'Save',
            loading_label: 'Saving…',
            className: 'button fullwidth dark primary xlarge',
        },
    ],
}

const contact_list = [
    {
        id: 'ask_me',
        label: 'Ask me about…',
        glyph: 'lightbulb',
        message_placeholder: 'Type your question here…',
        tweet_text(user) {
            return `Ask me about ${user.get('spotlight.text')} from my @aboutdotme page! 🤔❓`
        },
        fields: [custom_text, note, buttonset],
    },
    {
        id: 'book_consultation',
        label: 'Book a consultation',
        glyph: 'hireme',
        tweet_text(user) {
            return 'Book a consultation with me from my @aboutdotme page! ☎️📆'
        },
        fields: [note, buttonset],
    },
    {
        id: 'contact_me',
        label: 'Contact me',
        glyph: 'email',
        default: true,
        tweet_text(user) {
            return 'Contact me from my @aboutdotme page! 📬✉️'
        },
        fields: [note, buttonset],
    },
    {
        id: 'get_in_touch',
        label: 'Get in touch',
        glyph: 'email',
        tweet_text(user) {
            return 'Get in touch from my @aboutdotme page! 📬✉️'
        },
        fields: [note, buttonset],
    },
    {
        id: 'hire_me',
        label: 'Hire me',
        glyph: 'hireme',
        tweet_text(user) {
            return 'Hire me from my @aboutdotme page! 💼👍'
        },
        fields: [note, buttonset],
    },
    {
        id: 'send_message',
        label: 'Send me a message',
        glyph: 'email',
        fields: [note, buttonset],
    },
]

// assign contact mechanism
// all spotlights in this list are premium
contact_list.forEach(spotlight => {
    spotlight.is_premium = true
    spotlight.mechanism = 'contact'
    spotlight.group = 'contact'
})

module.exports = contact_list
